export const delayTime = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
